import { render, staticRenderFns } from "./m-edit-contact.vue?vue&type=template&id=6a5cf558&scoped=true&lang=pug"
import script from "./m-edit-contact.vue?vue&type=script&lang=js"
export * from "./m-edit-contact.vue?vue&type=script&lang=js"
import style0 from "./m-edit-contact.vue?vue&type=style&index=0&id=6a5cf558&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5cf558",
  null
  
)

export default component.exports